export type BonMediaTypeAllowed = "png" | "svg" | "jpg" | "mov" | "webm";

export const bonImgUrl = (imageName: string, imageType: BonMediaTypeAllowed, queryString?: string) => {
    return queryString
        ? `/frontend/web/img/casino/bonusomat/${imageName}.${imageType}?${queryString}`
        : `/frontend/web/img/casino/bonusomat/${imageName}.${imageType}`;
};
